"use client";

import * as React from "react";
import { cn } from "../../lib/utils";
import { Sheet, SheetContent, SheetTitle } from "./sheet";

export interface SideOverlayDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  headerAction?: React.ReactNode;
  onBack?: () => void;
  className?: string;
  children: React.ReactNode;
}

export function SideOverlayDrawer({
  isOpen,
  onClose,
  title,
  headerAction,
  onBack,
  className,
  children,
}: SideOverlayDrawerProps) {
  const handleOpenChange = (open: boolean) => {
    if (!open) onClose();
  };

  const fallbackTitle = "Drawer panel";

  return (
    <Sheet open={isOpen} onOpenChange={handleOpenChange}>
      <SheetContent
        side="right"
        className="border-none bg-transparent p-0 shadow-none"
        aria-label={title ?? fallbackTitle}
      >
        <div
          className={cn(
            "ml-auto flex h-dvh w-full overflow-y-scroll flex-col bg-[#FFF9EF] px-4 pb-6 pt-5 ",
            className
          )}
        >
          {(title || onBack || headerAction) && (
            <div className="mb-5 flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                {onBack && (
                  <button
                    type="button"
                    onClick={onBack}
                    aria-label="Go back"
                    className="flex h-8 w-8 items-center justify-center rounded-md text-[#344054]"
                  >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.625 3.75L6.375 9L11.625 14.25"
                        stroke="#344054"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                )}
                <SheetTitle className={cn("text-lg font-semibold text-[#344054]", !title && "sr-only")}>
                  {title ?? fallbackTitle}
                </SheetTitle>
              </div>
              {headerAction}
            </div>
          )}
          {!title && !onBack && !headerAction && (
            <SheetTitle className="sr-only">{fallbackTitle}</SheetTitle>
          )}
          <div className="flex-1 overflow-y-auto">{children}</div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
